import React from 'react';
import { CardExpiryElement } from '@stripe/react-stripe-js';
import { IPayments } from 'interfaces/payment';

const CardExpiry: React.SFC<IPayments.ICardElementProp> = props => {
  return (
    <div className='form-group'>
      <label>Expiration MM/YY</label>
      <div className='form-control' id='card-expiry-element'>
        <CardExpiryElement
          options={props.styles}
        />
      </div>
    </div>
  );
};

export default CardExpiry;
